;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import { assetFragment } from 'lib/graphql/fragments';

import BlockNewsletter from './BlockNewsletter';

const query = /* GraphQL */ `
    ${assetFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockNewsletter(preview: $preview, id: $id) {
            __typename
            klaviyoSource
            headline {
                json
            }
            copy {
                json
            }
            image {
                ...Asset
            }
            imageOnLeft
            flushTop
            flushBottom
            anchorId
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockNewsletter },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });
    return blockNewsletter;
}

const BlockNewsletterServer = async ({ id }) => {
    const block = await fetchBlock(id);
    return <BlockNewsletter {...block} />;
};

export default BlockNewsletterServer;
